import React from "react";
import UserDetails from "../../../containers/SignUpSteps/UserDetails/UserDetails";
import SignUpHoc from "../../../hoc/SignUpHoc/SignUpHoc";
import VerifyEmail from "../../../containers/SignUpSteps/VerifyEmail/VerifyEmail";
import JoinStudio from "../../../containers/SignUpSteps/JoinStudio/JoinStudio";
import { connect } from "react-redux";
import { updateProfile } from "../../../redux/actions/profileAction";
import { profileActions } from "../../../store";
import Waiver from "../../../containers/SignUpSteps/Waiver/Waiver";

const SignUpStepsWrapper = ({ signUpForm, status, ...props }) => {
  return (
    <React.Fragment>
      {status === "userDetails" ? (
        <UserDetails {...props} userDetail={signUpForm.controls.userDetail} />
      ) : null}
      {status === "verifyEmail" ? (
        <VerifyEmail {...props} userDetail={signUpForm.controls.userDetail} />
      ) : null}
      {status === "joinStudio" ? (
        <JoinStudio {...props} signUpForm={signUpForm} />
      ) : null}
      {status === "waiver" ? <Waiver {...props} /> : null}
    </React.Fragment>
  );
};

const SignUpStepsWrapperComponent = SignUpHoc(SignUpStepsWrapper);

const mapStateToProps = (state) => {
  return {
    profile: { ...state.profile.profileData },
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateProfileData: (data) => dispatch(profileActions.updateProfileData(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpStepsWrapperComponent);
// export default SignUpStepsWrapperComponent;
